import React from "react";
import { Redirect } from "react-router-dom";
import { AppRouteURI } from "../../router/RoleBasedAccess";

const NotFound = () => <Redirect to={AppRouteURI.HOME} />;

export default NotFound;
